import { RECENTLY_VIEWED_LOCAL_STORAGE_NAME } from 'bundles/search-common/constants';
import { getItemsListFromLocalStorageByKeyAndTrimOutdated } from 'bundles/search-common/utils/SearchUtils';

/**
 * @description show default inferred role if user has viewed more than 3 pathway related items
 */
const showDefaultInferredRole = () => {
  const recentlyViewed = getItemsListFromLocalStorageByKeyAndTrimOutdated(RECENTLY_VIEWED_LOCAL_STORAGE_NAME);

  const pathwayRelatedItems = recentlyViewed.filter(
    (item) => item.productType === 'Career Role' || item.isPathwayProduct
  );

  return pathwayRelatedItems.length > 3;
};

export default showDefaultInferredRole;
